import axios from 'axios';

export const getErrorMessage = (error: unknown): string => {
    if (axios.isAxiosError(error)) {
        return error.response?.data?.message || error.message || 'An error occurred with the request';
    }

    if (error instanceof Error) return error.message;
    if (typeof error === 'string') return error;

    return 'An unexpected error occurred';
};
